import useSWR from 'swr'
import { fetcher } from '../utils/api'

export function useSupportCount() {
  const { data, error, mutate } = useSWR(
    '/api/admin/support/all?status=open',
    fetcher,
    {
      refreshInterval: 30000, // Refresh every 30 seconds
      revalidateOnFocus: true,
      dedupingInterval: 10000,
    }
  )
  
  return {
    openCount: data?.counts?.open || 0,
    pendingCount: data?.counts?.pending || 0,
    totalUnread: (data?.counts?.open || 0) + (data?.counts?.pending || 0),
    isLoading: !error && !data,
    isError: error,
    refresh: mutate
  }
}
